import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformDocumentType'
})
export class TransformDocumentType implements PipeTransform {
  transform(value: number): string {
    if(value === 1) return 'DNI';
    if(value === 2) return 'Pasaporte';
    if(value === 3) return 'Carnet de extranjero';
    return 'Documento';
  }
}
